import { createAction, props } from '@ngrx/store';
import { RequestFinancialDataManagerCreate, ResponseFinancialDataManagerCreate } from '../../shared/interfaces';
import { FinancialDataManagerCreateTypes } from '../../shared/enums';

export const getFinancialDataManagerCreate = createAction(
    FinancialDataManagerCreateTypes.FINANCIAL_DATA_MANAGER_CREATE,
    props<{ request: RequestFinancialDataManagerCreate}>()
);

export const getFinancialDataManagerCreateSucess = createAction(
    FinancialDataManagerCreateTypes.FINANCIAL_DATA_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseFinancialDataManagerCreate }>()
);

export const getFinancialDataManagerCreateError = createAction(
    FinancialDataManagerCreateTypes.FINANCIAL_DATA_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    FinancialDataManagerCreateTypes.CLEAN_STATE
);

